// extracted by mini-css-extract-plugin
export default {"label":"PromotionDetailModal_label__1aJo2"};